export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname.includes('localhost');

  if (isLocalhost) {
    // For local development: "subdomain.localhost"
    const parts = hostname.split('.');
    return parts.length > 1 ? parts[0] : null;
  }

  // For production domains
  const domainParts = hostname.split('.');
  if (domainParts.length > 2) {
    return domainParts.slice(0, -2).join('.');
  }

  return null;
};



